<template>
  <div id="GameCell" :class="{ mobile: device == 'mobile' }" v-if="dataSource">
    <div class="name">
      <div class="avatar" @click="goto()">
        <div class="avatarInside">
          <!-- <img :src="dataSource.imgUrl" alt> -->
          <img v-lazy="{ src: qiniuUrl + dataSource.netImgUrl }" />
        </div>
      </div>
      <!-- <p>{{dataSource.gameName}}第{{dataSource.issueId}}期开奖</p> -->
      <p>{{ dataSource.memo }}第{{ dataSource.issueId }}期开奖</p>

      <span
        >当前{{ dataSource.todaySeq }}期，剩余{{
          dataSource.issueNum - dataSource.todaySeq
        }}期</span
      >
      <span class="time">{{ showTime }}</span>
    </div>
    <ResBall
      class="resball"
      :showTime="showTime"
      :type="dataSource.type"
      :dataSource="dataSource"
    ></ResBall>
    <ResPatterns
      class="resPatterns"
      :type="dataSource"
      :dataSource="dataSource.lastResult"
    ></ResPatterns>
    <!-- <div class="tobet" @click="handleLinkSite">立即投注</div> -->
    <div class="graphs">
      <!-- <span @click="goto('Lishikaijiang')">历史开奖</span> -->
      <!-- <span>{{dataSource.type}}</span> -->
      <!-- <span @click="goto('Jishikaijiang')">历史开奖</span>
      <span @click="goto('Luzhufenxi')">路珠分析</span>
      <span @click="goto('Lenrefenxi')">冷热分析</span>
      <span @click="goto('Hezhizoushi')">冠亚和走势</span>-->

      <span
        v-for="(it, i) in menus[dataSource.type].slice(0, 4)"
        :key="i"
        @click="goto(it.alias)"
        >{{ it.name }}</span
      >
    </div>
  </div>
</template>

<script>
import ResBall from "../../components/ResBall";
import ResPatterns from "./ResPatterns";
import { mapState, mapGetters } from "vuex";
import { formatSeconds } from "../../helpers/util.js";
import menus from "../../helpers/trendMenus.js";

export default {
  name: "GameCell",
  props: ["dataSource"],
  data() {
    return {
      second: 0,
      timeDown: null,
      reGetNum: 0,
      menus: menus
    };
  },
  components: {
    ResBall,
    ResPatterns
  },
  computed: {
    ...mapState(["hotGame", "linkUrl", "device", "qiniuUrl"]),
    showTime() {
      if (this.dataSource.issueId == this.dataSource.lastResultIssueID) {
        return "停售中";
      }
      if (this.second >= 0) {
        let arr = formatSeconds(this.second);
        // console.log(arr, "arr");

        let str = "";
        str += arr[0] === "00" ? "" : `${arr[0]}时`;
        str += arr[1] === "00" ? "" : `${arr[1]}分`;
        str += `${arr[2]}秒`;
        return str;
      }
      if (this.second < 0 && this.second > -10) {
        return "开奖中";
      }
      if (this.second <= -10) {
        // return "已封盘";
        return "开奖中";
      }
    }
  },
  watch: {
    dataSource: {
      immediate: true,
      handler() {
        this.init();
      }
    }
  },
  methods: {
    init() {
      clearInterval(this.timeDown);
      this.second =
        (this.dataSource.GMTcloseTime - this.dataSource.GMTcurTime) / 1000;
      this.timeDown = setInterval(() => {
        this.second--;
        if (this.second < 0 && this.second > -10) {
          this.$emit("needGetData", this.dataSource.gameType);
          clearInterval(this.timeDown);
        }
        if (this.second <= -10) {
          clearInterval(this.timeDown);
        }
      }, 1000);
    },
    goto(type) {
      this.$router.push(
        `/Trend/${this.dataSource.type}/${this.dataSource.gameType}${
          type ? "?modeType=" + type : ""
        }`
      );
    },
    handleLinkSite() {
      window.open(this.linkUrl, "_blank");
    }
  }
};
</script>

<style lang="less" scoped>
#GameCell {
  // position: relative;
  float: left;
  // width: 463px;
  width: 48%;
  height: 340px;
  padding-top: 28px;
  margin-right: 15px;
  background-color: #fff;
  box-sizing: border-box;
  margin-bottom: 15px;

  &.mobile {
    width: 100%;
  }
  &:hover {
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
  }
  .name {
    position: relative;
    height: 100px;
    padding-left: 148px;
    .avatar {
      cursor: pointer;
      position: absolute;
      width: 100px;
      height: 100px;
      left: 28px;
      background-color: rgb(240, 240, 240);
      border-radius: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      .avatarInside {
        width: 80px;
        height: 80px;
        padding: 15px;
        box-sizing: border-box;
        background-color: #fff;
        border-radius: 100%;
      }
      img {
        width: 50px;
        height: 50px;
        transition: all 0.6s;
      }
      img:hover {
        transform: rotate(360deg);
      }
    }
    p {
      font: 18px/1 Tahoma;

      color: #333333;
      // line-height: 40px;
      line-height: 30px;
      height: 60px;
    }
    span {
      font-size: 14px;
      color: #999;
      line-height: 30px;
    }
    .time {
      color: #ff0000;
      margin-left: 10px;
    }
  }
  .resball {
    margin-top: 25px;
    padding-left: 28px;
    height: 40px;
  }
  .resPatterns {
    padding: 0 28px;
    margin: 20px 0;
    height: 60px;
  }
  .tobet {
    cursor: pointer;
    // width: 407px;
    width: 90%;
    background-color: red;
    border: 1px solid #ffb6b6;
    line-height: 42px;
    height: 42px;
    text-align: center;
    color: #fff;
    border-radius: 3px;
    margin: 0 auto;
    font-size: 18px;
  }
  .graphs {
    // position: absolute;
    bottom: 0;
    border-top: 1px solid #f0f0f0;
    display: flex;
    width: 100%;
    height: 45px;
    line-height: 45px;
    margin-top: 5px;
    span {
      cursor: pointer;
      flex: 1;
      text-align: center;
      font-size: 14px;
      color: #333;
      &:hover {
        color: #fa8e19;
      }
    }
  }
}
#GameCell:hover .avatarInside img {
  transform: rotate(45deg);
  transition: all 0.6s;
}
</style>



// WEBPACK FOOTER //
// src/pages/Home/GameCell.vue